import globals from '~/globals';
import Circle from 'Components/Circle';
import Drawer from 'Components/Drawer';
import Panel from 'Components/Panel';
import SimpleList from 'Components/SimpleList';
import { actions as deviceActions } from 'ducks/devices';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { unixToDate } from 'utils/date';
import icons from 'utils/ui/icons';
import CreateTemplate from './CreateTemplate';
import ReclaimWiseBox from './ReclaimWiseBox';

const generateLastModification = device => {
    const color = device.locally_synced ? '#2C6700' : '#B94A48';

    return (
        <>
            <Circle color={color}/>
            &nbsp;
            {unixToDate(device.configuration_last_modification)}
        </>
    );
};

const generateRegistered = device => {
    const color = device.registered_at ? '#2C6700' : '#B94A48';

    return (
        <>
            <Circle color={color}/>
            &nbsp;
            {device.registered_at ? unixToDate(device.registered_at) : 'Not yet registered'}
        </>
    );
};

const Component = props => {
    const { device } = props;

    const [drawer, setOpenDrawer] = useState(null);
    const closeDrawer = () => setOpenDrawer(null);

    const dispatch = useDispatch();
    const rotateToken = () => dispatch(deviceActions.rotateToken(device.id));

    const wiseBoxAttributes = [
        { label: 'Balena ID', content: device.balena_id ? device.balena_id : 'Not settled' },
        { label: 'Balena UUID', content: device.balena_uuid ? device.balena_uuid : 'Not settled' },
        {
            label: 'Claimed',
            content: device.claimed_at ? `${unixToDate(device.claimed_at)} by ${device.claimer_name}` : 'not claimed'
        },
        { label: 'Registration Date', content: generateRegistered(device) },
        { label: 'Last Configuration Change', content: generateLastModification(device) }
    ];

    const wiseBoxButtons = [];

    wiseBoxButtons.push(
        {
            icon: icons.reclaim,
            onClick: () => setOpenDrawer('reclaim'),
            tooltip: 'Reclaim WiseBox'
        },
        {
            icon: icons.templateCreate,
            onClick: () => setOpenDrawer('createTemplate'),
            tooltip: 'Create New Template'
        },
        {
            icon: icons.pdf,
            onClick: () => window.open(`${globals.apiUrl}/devices/${device.id}/template`, '_blank'),
            tooltip: 'Download Installation Report'
        },
        {
            icon: icons.regenerate,
            onClick: () => rotateToken(),
            tooltip: 'Rotate Token'
        }
    );

    let DrawerContent;
    if (drawer === 'createTemplate') {
        DrawerContent = (
            <CreateTemplate closeDrawer={closeDrawer} id={device.id}/>
        );
    } else if (drawer === 'reclaim') {
        DrawerContent = (
            <ReclaimWiseBox closeDrawer={closeDrawer} id={device.id}/>
        );
    }

    return (
        <>
            <Panel buttons={wiseBoxButtons}>
                <SimpleList content={wiseBoxAttributes}/>
            </Panel>
            <Drawer onClose={closeDrawer} open={!!drawer}>
                {DrawerContent}
            </Drawer>
        </>
    );
};

export default Component;
